// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","392":"banner","443":"about","471":"show","601":"faction"}[chunkId] + "." + {"18":"c2ae6b29","392":"7d366ff3","443":"22949f3c","471":"b80962d8","601":"365c0874"}[chunkId] + ".css";
};